<div class="relative flex flex-grow flex-col overflow-hidden bg-text-primary">
  <div class="z-10 flex flex-grow flex-col overflow-hidden rounded-t-[20px] bg-background-white">
    <div #header class="grid transition-all" style="grid-template-rows: 1fr">
      <div>
        <div class="relative z-[2000]">
          <lib-ffd-notes-header
            class="relative z-[2000] bg-text-white"
            [loggedInUser]="currentUser()"
            [selectedSite]="selectedSite()"
            [sitesCount]="sitesCount()"
            (logout)="onLogout()"
            (support)="onSupport()"
          ></lib-ffd-notes-header>
        </div>
        @if (showNudge()) {
          <div
            class="bg-white relative z-[1000] -mt-18 flex items-center justify-between overflow-hidden rounded-b-[20px] border border-background-light-blue px-10 pb-2 pt-20"
          >
            <span class="z-10 text-h5 font-semibold text-primary-blue">{{ 'express_app_ffd_notes_slogan' | translate }} </span>
            <div class="nudge absolute bottom-0 right-0 flex h-11 w-full justify-end">
              <img class="h-full w-[80%] overflow-visible object-cover" src="assets/images/trial-bar-bg.jpg" />
            </div>
          </div>
        }
      </div>
    </div>
    <router-outlet></router-outlet>
  </div>

  @if (assistantLauncherService.collabId()) {
    <lib-assistant-launcher-button
      class="absolute bottom-16 left-8 z-[999]"
      [siteId]="selectedSite()?.id"
      [isInsideTrialPeriod]="selectedSite()?.isInsideTrialPeriod ?? false"
      (toggleClicked)="assistantChatWindowService.toggle()"
    ></lib-assistant-launcher-button>

    <lib-assistant-chat-window
      class="absolute bottom-5 left-5 z-[999]"
      [siteId]="selectedSite()?.id"
      [isInsideTrialPeriod]="selectedSite()?.isInsideTrialPeriod ?? false"
      [dragTopBoundary]="header"
    ></lib-assistant-chat-window>
  }
</div>
